import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var ProfileAddContact = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_ProfileAddContact_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9a.5.5 0 0 0 1 0V7.5h1.5a.5.5 0 0 0 0-1H14V5a.5.5 0 0 0-1 0v1.5h-1.5a.5.5 0 0 0 0 1H13V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.2C0 10.88 2.8 9 7 9s7 1.88 7 4.2a2.8 2.8 0 0 1-2.8 2.8H2.8A2.8 2.8 0 0 1 0 13.2Zm1 0c0-.713.424-1.482 1.452-2.12C3.482 10.44 5.037 10 7 10s3.518.441 4.548 1.08C12.576 11.718 13 12.487 13 13.2a1.8 1.8 0 0 1-1.8 1.8H2.8A1.8 1.8 0 0 1 1 13.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_ProfileAddContact_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default ProfileAddContact;